import { all, put, takeEvery } from 'redux-saga/effects';

import logging from '../../lib/logging';
import * as actions from './actions';
import { isErrorAction } from './helpers';
import { NotificationTypes } from './constants';

function getError(action) {
  if (typeof action.error === 'string') {
    return [action.error];
  }

  if (Array.isArray(action.error)) {
    return action.error;
  }

  if (action.error.error) {
    return action.error.error;
  }

  return undefined;
}

function* addError(action) {
  try {
    if (action.error) {
      const errors = getError(action);

      if (errors && errors.map) {
        yield* errors.map(error => put(
          actions.add({
            type: NotificationTypes.ERROR,
            message: error,
          }),
        ));
      } else {
        if (action.type.indexOf('@@redux-form') !== -1) {
          return;
        }
        const urlParams = action.url && action.url.indexOf('?') !== -1 ?
          action.url.split('?')[1] : undefined;
        logging.error('Error not displayed', {
          extra: {
            action,
            urlParams,
          },
        });
      }
    }
  } catch (error) {
    logging.error(error);
  }
}

export default function* defaultSaga() {
  yield all([
    takeEvery(isErrorAction, addError),
  ]);
}
